import { useState, useEffect } from 'react'
import { useMutation } from 'react-query'
import { uploadImage, deleteImage, getImage } from '@app-core/api'
import { useArticleContext } from '../../_core'
import SocialMediaImageSettingView from './SocialMediaImageSettingView'

function SocialMediaImageSetting() {
  const {
    articleState: { ogImageId, imageIds },
  } = useArticleContext()

  const [uploadImageMutate] = useMutation(uploadImage)
  const [deleteImageMutate] = useMutation(deleteImage)

  // og 圖只會有一張，但因為使用 FileUpload 處理上傳邏輯，state 目前統一用 Array
  const [selectedOgImage, setSelectedOgImage] = useState([])
  useEffect(() => {
    const id = ogImageId ? ogImageId : imageIds?.[0]
    if (!id) return
    const getOgImageFromId = async () => {
      const response = await getImage({ id })
      if (response.data) {
        const image = {
          ...response.data,
          upload: {
            success: true,
            errorCodes: [],
          },
        }
        setSelectedOgImage([image])
      }
    }
    getOgImageFromId()
  }, [imageIds, ogImageId])

  return (
    <SocialMediaImageSettingView
      onImageUpload={uploadImageMutate}
      onImageDelete={deleteImageMutate}
      selectedOgImage={selectedOgImage}
      setSelectedOgImage={setSelectedOgImage}
    />
  )
}

export default SocialMediaImageSetting
